module.exports = __webpack_public_path__ + "img/ellipse2.6c78662.png";